import React from "react";
import { Link } from "react-router-dom";
import { Card, Grid, Icon, SemanticICONS } from "semantic-ui-react";

import { Roles } from "../../interfaces";
import { GetUser } from "../../services/auth";

export interface ICardMenu {
    path: string | object;
    icon: SemanticICONS;
    corner?: SemanticICONS;
    text: string;
    roles: Roles[];
    show: boolean;
}

const CardMenu: React.FC<ICardMenu> = ({ path, icon, corner, text, roles, show }: ICardMenu) => {
    const { role } = GetUser();
    if (roles.find(x => x === role) && show) {
        return (
            <Grid.Column>
                <Card className="swing-in-bottom-bck card-custom" as={Link} to={path} centered>
                    <Card.Content>
                        <Card.Header>
                            <Grid centered>
                                <Grid.Row textAlign="center">
                                    <Icon.Group size="huge">
                                        <Icon inverted name={icon} color="black" />
                                        {!!corner && <Icon corner name={corner} />}
                                    </Icon.Group>
                                </Grid.Row>
                                <Grid.Row textAlign="center">{text}</Grid.Row>
                            </Grid>
                        </Card.Header>
                    </Card.Content>
                </Card>
            </Grid.Column>
        );
    } else {
        return null;
    }
};

export default CardMenu;
